// Note: The first file of a module here, must also register the module

import "./general-info-code.component";
import "./general-info.component";
